import { EasyBrief } from './components/EasyBrief';
import { TipsAndGuides } from './components/TipsAndGuides';

export const HowToSection: React.FC = () => {
	return (
		<div data-testid="homepage-how-to-section" className="relative">
			<EasyBrief />
			<TipsAndGuides />
		</div>
	);
};
